
<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <div class="" >
      <div class="step-title">第一步</div>
      <div class="step-con">
        根据模板填写并上传文件
        <span class="step-a">下载模板</span>
      </div>
      <div class="step-title">第二步</div>
      <div class="step-con">
        按照模板格式填写后上传Execl文件
        <a-upload
          name="file"
          :file-list="fileList"
          :remove="handleRemove"
          :showUploadList="true"
          :multiple="false"
          :headers="tokenHeader"
          @change="handleImportExcel"
          :before-upload="beforeUpload">
          <a-button type="default" icon="import">选择文件</a-button>
        </a-upload>

        <!-- <a-button type="primary" icon="plus" style="float:right;" >选择文件</a-button> -->
      </div>
      <div class="step-title">第三步</div>
      <div class="step-con">
        选择题目分类
        <a-form-item
          style="margin-bottom:0px;width:160px;display: inline-block;vertical-align: middle;"
          label=""
          :required="false"
        >
          <!-- <j-dict-select-tag placeholder="选择科目" dictCode="subjectSkill" style="width:100%" :triggerChange="triggerChange"/> -->
          <a-tree-select
            v-model="catalogId"
            style="width: 100%"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            placeholder="请选题库分类"
            allow-clear
            tree-default-expand-all
            :replaceFields="replaceFields"
            :treeData="gData">
          </a-tree-select>
        </a-form-item>
      </div>
    </div>
  </a-modal>
</template>

<script>
  import {queryExerciseTreeList,importExercise} from '@/api/api'
  import Vue from 'vue'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import { uploadAction } from '@/api/manage'
  export default {
    name: 'ExportExerciseModal',
    components: {
    },
    data () {
      return {
        triggerChange: true,
        fileList: [],
        title: '批量导入题目',
        width: 800,
        visible: false,
        disableSubmit: false,
        tokenHeader: '',
        catalogId:undefined,
        gData:[],
        reqData:{},
        replaceFields : {
          title:'name'
        },
        importUrl: "exercise/elinkxExerciseInfo/importExercise",
        // gData: [
        //   {
        //     id: 1,
        //     key: 1,
        //     isEdit: false, // 是否处于编辑状态
        //     isNewItem: false, // 该节点是否是新增节点
        //     title: '节点名字',
        //     depth: 1, // 该节点的层级
        //     scopedSlots: { title: 'title' }, // 自定义组件需要绑定
        //     children: [
        //       {
        //         id: 2,
        //         key: 2,
        //         isEdit: false, // 是否处于编辑状态
        //         isNewItem: false, // 该节点是否是新增节点
        //         title: '子节点名字',
        //         depth: 2, // 该节点的层级
        //         scopedSlots: { title: 'title' }
        //       },
        //       {
        //         id: 21,
        //         key: 21,
        //         isEdit: false, // 是否处于编辑状态
        //         isNewItem: false, // 该节点是否是新增节点
        //         title: '子节点名字',
        //         depth: 2, // 该节点的层级
        //         scopedSlots: { title: 'title' }
        //       }
        //     ]
        //   }
        // ]
      }
    },
    methods: {
      // 显示弹框
      open () {
        this.loadTree();
       // this.gData = treeData;
        this.visible = true

      },
      // 选择完导入文件
      beforeUpload(file) {
        this.fileList = [file]
        return false
      },
      // 删除导入文件
      handleRemove(file) {
        const index = this.fileList.indexOf(file)
        const newFileList = this.fileList.slice()
        newFileList.splice(index, 1)
        this.fileList = newFileList
      },
      close () {
        this.$emit('close')
        this.visible = false
      },
      handleOk () {
        if (!this.catalogId){
          this.$message.warning("请选择分类目录！")
          return;
        }

        let formData = new FormData()
            formData.append('file', this.fileList[0]);
            formData.append('catalogId', this.catalogId);
           
            uploadAction(window._CONFIG['domianURL']+"/exercise/elinkxExerciseInfo/importExercise", formData).then((res) => {
              if (res.success) {
                console.log(res);
                this.$emit('ok')
                this.$emit('close')
                this.visible = false
              }else{
                this.$message.warning(res.message)
              }
            })



        // importExercise({file:this.fileList[0],catalogId:this.catalogId}).then((res)=>{
        //   if(res.success){
        //     console.log(res);
        //   }else{
        //     this.$message.warning(res.message)
        //   }
        // }).finally(() => {
        // })
        // this.$refs.realForm.submitForm()
      },
      submitCallback() {
        this.$emit('ok')
        this.visible = false
      },
      handleImportExcel(info){
        console.log(info.file.status);
        console.log(info)
        // if (info.file.status !== 'uploading') {
        //   console.log(info.file, info.fileList);
        // }
      },
      loadTree(){
        queryExerciseTreeList().then((res) => {
           if (res.success) {
             this.gData=res.result;
             this.gData.forEach(item=>{
               item.selectable = false;
             })
           }else {
            this.$message.warning(res.message)
          }
        console.log(res);
        }).finally(() => {
        })
      },
      handleCancel () {
        this.close()
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.importUrl}`;
      }
    },
    created () {
      const token = Vue.ls.get(ACCESS_TOKEN)
      this.tokenHeader = { 'X-Access-Token': token }
    }
  }
</script>
<style lang="less" scoped >
  .step-title{
    margin-bottom: 10px;
    font-weight: bold;
  }
  .step-con{
    margin-bottom: 10px;
  }
</style>
